// @flow

import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';
import { validatePhilippinePhone } from '@tectonics/prs/philippines/validation/philippine-phone';

export function philippinesOutgoingPaymentMapper(userInputValues: UserInputValues): $Shape<OutgoingPayment> {
  const phoneNumber = userInputValues['philippinesPhoneNumber'];

  return {
    country: 'ph',
    ...(validatePhilippinePhone(phoneNumber) ? {} : { phone_number: phoneNumber }),
  };
}
